<!--
 * @Author: your name
 * @Date: 2020-09-28 19:29:53
 * @LastEditTime: 2020-11-25 16:32:03
 * @LastEditors: Zed
 * @Description: In User Settings Edit
 * @FilePath: \bidding-oa-web\src\views\components\resultTable.vue
-->
<template>
    <el-table :data="list" :show-header="!hideHeader" style="width: 100%;"  @row-click="onInfo">
      <el-table-column  width="30px" :show-overflow-tooltip="true" label="" prop="title">
        <template slot-scope="scope">
          <img src="@/assets/images/download.png" height="20" alt="" srcset="" class="concatItem">
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="下载标题" prop="title">
        <template slot-scope="scope">
          <a href="javascript:;" class='sucess'>{{ scope.row.title }}</a>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="下载摘要" prop="summary" v-if="!hideHeader">
        <template slot-scope="scope">
          <a href="javascript:;" class='sucess'>{{ scope.row.summary }}</a>
        </template>
      </el-table-column>
      <el-table-column :show-overflow-tooltip="true" label="创建日期" prop="createTime" width="140">
        <template slot-scope="scope">
          <div class="release-time">{{ scope.row.createTime }}</div>
        </template>
      </el-table-column>
      <div slot="empty" class="empty">
      <el-empty description="暂无数据" />
    </div>
    </el-table>
</template>

<script>
import announcement from "@/api/announcement/announcement"
export default {
  props: {
    list: Array,
    hideHeader: Boolean
  },
  data() {
    return {
      dialogVisible: false,
      detailList: [],
      total: '',
      query: {
        current: 1,
        size: 4,
        projectId: ''
      },
    }
  },
  methods: {
    onInfo(row) {
      console.log(row);
      this.$router.push({
        path: "/detail",
        query: {
          id: row.id,
          type: 4,
        }
      })
      // window.open(row.projectResultBulletinUrl)
    },
    handleClick(row) {
      console.log(row)
      this.query.projectId = row.projectId
      this.queryResultBulletinList(row.projectName)
    },
    handleClose() {
      this.dialogVisible = false;
    },

    queryResultBulletinList(projectName) {
      announcement.queryOriginalResultBulletinList(this.query).then(
        res => {
          console.log("结果公告", res);
          if (res.code === 200) {
            if (res.data.records.length > 0) {
              this.dialogVisible = true
              console.log(res.data);
              this.detailList = res.data.records;
              for (let i in this.detailList) {
                this.detailList[i].projectName = projectName
              }

              this.total = res.data.total;
            } else {
              this.$message.warning("暂无结果更新公告")
            }

          }
        }
      )
    },
    handleSizeChange(val) {
      this.query.size = val;
      this.queryResultBulletinList()
    },
    handleCurrentChange(val) {
      this.query.current = val;
      this.queryResultBulletinList()
    }
  },
  created() {
    // console.log(this.list);
  },
}
</script>

<style lang="less" scoped>
.release-time {
  color: #999999;
  font-size: 16px;
}

.sucess {
  color: #131313;
  text-decoration: none;
  cursor: pointer;
  font-size: 16px;
  margin: 0

}

.el-pagination {
  text-align: center;
  margin-top: 20px;
}

/deep/.el-button--small {
  padding: 0
}
</style>